import FilterDialog from './Dialog'
import { useSelector } from 'react-redux'
import FilterButton from '../../../../../../filter/FilterButton'

const FilterButtonUsersClass = () => {
  const open = useSelector(state => state?.filter?.groupStudents?.open || false)

  return (
    <>
      <FilterButton 
        module='groupStudents' 
        keysFilter={[
          'yearLevelId', 'rolesId', 'roles', 'userIds', 'rolesId',
          'lcElements',
          'ulId',
          'classId',
          'student',
          'yearLevelId',
          'code',
          'firstName',
          'lastName',
          'houseId',
          'house',
          'formId',
          'form',
          'preferredName'
        ]} 
        keepReload={false}
      />
      { open &&
        <FilterDialog />
      }
    </>
  )
}
export default FilterButtonUsersClass